import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import Text from '../../Text'
import { useGretaAIChatThinkingStatus } from '../GretaAIChat.hooks'

import { getGretaAIChatThinkingLabel } from './GretaAIChatThinkingIndicator.utils'

import * as styles from './GretaAIChatThinkingIndicator.module.css'

import GretaThinkingMark from '../../../icons/unique/ai/greta-thinking-mark.svg'

function GretaAIChatThinkingIndicator({
  className,
  fileName = null,
  turnStartedAt = null,
}) {
  const { t } = useTranslation()

  const { elapsedLabel, text } = useGretaAIChatThinkingStatus({
    turnStartedAt,
  })

  const label = getGretaAIChatThinkingLabel({ fileName, t, text })

  return (
    <div className={classNames(styles.indicator, className)}>
      <GretaThinkingMark aria-hidden='true' className={styles.mark} />

      {elapsedLabel ? (
        <Text isSecondary className={styles.elapsed}>
          {elapsedLabel}
        </Text>
      ) : null}

      <Text isSecondary className={styles.label}>
        {label}
      </Text>
    </div>
  )
}

export default GretaAIChatThinkingIndicator
